import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { CommunityAiUpgradeModalComponent } from "./CommunityAiUpgradeModalComponent";
import { CommunityAiUpgradeModalUIKitComponent } from "./CommunityAiUpgradeModalUIKitComponent";

export const useCommunityAiUpgradeModal = createCompassModalSwitcher(
  CommunityAiUpgradeModalComponent,
  CommunityAiUpgradeModalUIKitComponent,
);
